import React, { Component } from "react";
import dayjs from "dayjs";
import { Col, Image, Modal, Row, Tabs } from "antd";
import TrackingData from "../misc/TrackingData";

class ModalDetailBBN extends Component {
  constructor(props) {
    super(props);

    this.initState = {
      dataOrder: this.props.dataOrder ? this.props.dataOrder : {},
    };
    this.state = { ...this.initState };
  }

  copyToClipboard = async (data) => {
    await navigator.clipboard.writeText(data);
  };

  render() {
    const dataOrder = this.props.dataOrder;
    const bbnkb_opsen = Number(dataOrder?.vehicle_notice_data?.bbnkb_opsen) || 0;
    const pkb_opsen = Number(dataOrder?.vehicle_notice_data?.pkb_opsen) || 0;
    const calNoticeCost =
      Number(dataOrder?.vehicle_notice_data?.bbnkb) + bbnkb_opsen + Number(dataOrder?.vehicle_notice_data?.pkb) + pkb_opsen + Number(dataOrder?.vehicle_notice_data?.swdkllj) + Number(dataOrder?.vehicle_notice_data?.penerbitan_stnk) + Number(dataOrder?.vehicle_notice_data?.penerbitan_tnkb);

    const selisih_notice_dokumen_hitung = calNoticeCost - Number(dataOrder?.vehicle_notice_data?.jumlah);
    const selisih_notice_baru_lama = Number(dataOrder?.vehicle_notice_data?.jumlah) - Number(dataOrder.master_notice_cost);

    const total_bbn_lama = Number(dataOrder.master_notice_cost) + Number(dataOrder.process_cost);
    const total_bbn_baru = Number(dataOrder?.vehicle_notice_data?.jumlah) + Number(dataOrder.process_cost);
    const selisih_bbn = total_bbn_baru - total_bbn_lama;
    const total_bbn_tercatat = Number(dataOrder.transfer_title_cost);

    return (
      <Modal title="Detail Order" visible={this.props.visible} onCancel={this.props.onClose} footer={null} width={900} style={{ maxHeight: "80vh" }}>
        {dataOrder && (
          <div style={{ maxHeight: "calc(80vh - 55px)", overflowY: "auto" }}>
            <Tabs defaultActiveKey="1">
              <Tabs.TabPane tab="Data General" key="1">
                <TrackingData dataOrder={dataOrder}></TrackingData>
              </Tabs.TabPane>

              <Tabs.TabPane tab="Data Notice" key="2">
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Row>
                      <Col span={10}>Notice Approved</Col>
                      <Col span={14}>:&nbsp;{dataOrder?.payment_approved}</Col>
                    </Row>
                    <Row>
                      <Col span={10}>No Notice</Col>
                      <Col span={14}>:&nbsp;{dataOrder?.vehicle_notice_data?.no_notice}</Col>
                    </Row>
                    <Row>
                      <Col span={10}>Nomor Polisi</Col>
                      <Col span={14}>:&nbsp;{dataOrder?.vehicle_notice_data?.license_plate_number}</Col>
                    </Row>
                    <Row>
                      <Col span={10}>Nama Pemilik</Col>
                      <Col span={14}>:&nbsp;{dataOrder?.vehicle_notice_data?.customer_name}</Col>
                    </Row>
                    <Row>
                      <Col span={10}>Alamat</Col>
                      <Col span={14}>:&nbsp;{dataOrder?.vehicle_notice_data?.customer_address}</Col>
                    </Row>
                    <Row>
                      <Col span={10}>Nomor BPKB</Col>
                      <Col span={14}>:&nbsp;{dataOrder?.vehicle_notice_data?.bpkb_number}</Col>
                    </Row>
                    <Row>
                      <Col span={10}>Nomor Mesin</Col>
                      <Col span={14}>:&nbsp;{dataOrder?.vehicle_notice_data?.engine_number}</Col>
                    </Row>
                    <Row>
                      <Col span={10}>Nomor Rangka</Col>
                      <Col span={14}>:&nbsp;{dataOrder?.vehicle_notice_data?.chassis_number}</Col>
                    </Row>
                    <Row>
                      <Col span={10}>Kepemilikan Ke</Col>
                      <Col span={14}>:&nbsp;{dataOrder?.vehicle_notice_data?.ownership_order}</Col>
                    </Row>

                    <Row>
                      <Col span={10}>Ditetapkan Tanggal</Col>
                      <Col span={14}>:&nbsp;{dataOrder?.vehicle_notice_data?.issued_date}</Col>
                    </Row>
                    <Row>
                      <Col span={10}>Berlaku Sampai</Col>
                      <Col span={14}>:&nbsp;{dataOrder?.vehicle_notice_data?.expire_at}</Col>
                    </Row>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Row>
                      <Col span={10}>Biaya BBNKB</Col>
                      <Col span={14}>
                        :&nbsp;<strong style={{ fontSize: "90%" }}>{dataOrder?.vehicle_notice_data?.bbnkb?.toLocaleString()}</strong>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={10}>Biaya BBNKB Opsen</Col>
                      <Col span={14}>
                        :&nbsp;<strong style={{ fontSize: "90%" }}>{dataOrder?.vehicle_notice_data?.bbnkb_opsen?.toLocaleString()}</strong>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={10}>Biaya PKB + Progresif</Col>
                      <Col span={14}>
                        :&nbsp;<strong style={{ fontSize: "90%" }}>{dataOrder?.vehicle_notice_data?.pkb?.toLocaleString()}</strong>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={10}>Biaya PKB Opsen</Col>
                      <Col span={14}>
                        :&nbsp;<strong style={{ fontSize: "90%" }}>{dataOrder?.vehicle_notice_data?.pkb_opsen?.toLocaleString()}</strong>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={10}>Biaya SWDKLLJ</Col>
                      <Col span={14}>
                        :&nbsp;<strong style={{ fontSize: "90%" }}>{dataOrder?.vehicle_notice_data?.swdkllj?.toLocaleString()}</strong>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={10}>Biaya Penerbitan STNK</Col>
                      <Col span={14}>
                        :&nbsp;<strong style={{ fontSize: "90%" }}>{dataOrder?.vehicle_notice_data?.penerbitan_stnk?.toLocaleString()}</strong>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={10}>Biaya Penerbitan TNKB</Col>
                      <Col span={14}>
                        :&nbsp;<strong style={{ fontSize: "90%" }}>{dataOrder?.vehicle_notice_data?.penerbitan_tnkb?.toLocaleString()}</strong>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={10}>Biaya Notice Dokumen</Col>
                      <Col span={14}>
                        :&nbsp;<strong style={{ fontSize: "90%" }}>{dataOrder?.vehicle_notice_data?.jumlah?.toLocaleString()}</strong>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={10}>Biaya Notice Hitung</Col>
                      <Col span={14}>
                        :&nbsp;<strong style={{ fontSize: "90%" }}>{calNoticeCost ? calNoticeCost?.toLocaleString() : 0}</strong>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={10}>Selisih Notice Dokumen & Hitung</Col>
                      <Col span={14}>
                        :&nbsp;<strong style={{ fontSize: "90%", color: selisih_notice_dokumen_hitung !== 0 ? "red" : "inherit" }}>{selisih_notice_dokumen_hitung ? selisih_notice_dokumen_hitung?.toLocaleString() : 0}</strong>
                      </Col>
                    </Row>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <br />

                    <Row>
                      <Col span={10}>Biaya Proses</Col>
                      <Col span={14}>
                        :&nbsp;<strong style={{ fontSize: "90%" }}>{dataOrder.process_cost?.toLocaleString()}</strong>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={10}>Biaya Notice Lama</Col>
                      <Col span={14}>
                        :&nbsp;<strong style={{ fontSize: "90%" }}>{dataOrder.master_notice_cost?.toLocaleString()}</strong>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={10}>Biaya Notice Baru</Col>
                      <Col span={14}>
                        :&nbsp;<strong style={{ fontSize: "90%" }}>{dataOrder?.vehicle_notice_data?.jumlah?.toLocaleString()}</strong>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={10}>Selisih Notice Lama & baru </Col>
                      <Col span={14}>
                        :&nbsp;<strong style={{ fontSize: "90%", color: selisih_notice_baru_lama !== 0 ? "red" : "inherit" }}>{selisih_notice_baru_lama ? selisih_notice_baru_lama?.toLocaleString() : 0}</strong>
                      </Col>
                    </Row>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <br />
                    <Row>
                      <Col span={10}>Biaya BBN Lama</Col>
                      <Col span={14}>
                        :&nbsp;<strong style={{ fontSize: "90%" }}>{total_bbn_lama?.toLocaleString()}</strong>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={10}>Biaya BBN Baru</Col>
                      <Col span={14}>
                        :&nbsp;<strong style={{ fontSize: "90%" }}>{total_bbn_baru ? total_bbn_baru?.toLocaleString() : 0}</strong>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={10}>Selisih BBN Baru & Lama</Col>
                      <Col span={14}>
                        :&nbsp;<strong style={{ fontSize: "90%", color: selisih_bbn !== 0 ? "red" : "inherit" }}>{selisih_bbn ? selisih_bbn?.toLocaleString() : 0}</strong>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={10}>Biaya BBN Tercatat di DB</Col>
                      <Col span={14}>
                        :&nbsp;<strong style={{ fontSize: "90%" }}>{total_bbn_tercatat?.toLocaleString()}</strong>
                      </Col>
                    </Row>
                  </Col>
                  <Col xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <br />
                    <strong>Alasan Edit</strong>&nbsp;<pre>{dataOrder?.vehicle_notice_data?.description}</pre>
                  </Col>
                </Row>
                {dataOrder?.vehicle_notice_image && dataOrder?.vehicle_notice_image !== "https://otodis-bucket.s3.ap-southeast-1.amazonaws.com/undefined" && (
                  <Row>
                    <Col style={{ padding: 10 }}>
                      <br />
                      <Image width={"inherit"} src={dataOrder?.vehicle_notice_image} style={{ alignContent: "center" }} />
                    </Col>
                  </Row>
                )}
              </Tabs.TabPane>

              <Tabs.TabPane tab="Data Main Dealer" key="3">
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Row>
                      <Col span={8}>Penerima</Col>
                      <Col span={16}>:&nbsp;{dataOrder.daya_receiver_name}</Col>
                    </Row>
                    <Row>
                      <Col span={8}>ID Order</Col>
                      <Col span={16}>:&nbsp;{dataOrder.daya_id_order}</Col>
                    </Row>
                    <Row>
                      <Col span={8}>Tanggal BAST</Col>
                      <Col span={16}>:&nbsp;{dataOrder.daya_bast_date && dataOrder.daya_bast_date !== "NONE" ? dayjs(dataOrder.daya_bast_date).format("YYYY-MM-DD HH:mm") : "-"}</Col>
                    </Row>
                    <br />
                    <Row>
                      <Col span={8}>Nomor Invoice</Col>
                      <Col span={16}>:&nbsp;{dataOrder.daya_invoice_stnk}</Col>
                    </Row>
                    <Row>
                      <Col span={8}>Waktu Input Invoice</Col>
                      <Col span={16}>:&nbsp;{dataOrder.daya_input_time && dataOrder.daya_input_time !== "NONE" ? dayjs(dataOrder.daya_input_time).format("YYYY-MM-DD HH:mm") : "-"}</Col>
                    </Row>
                    <Row>
                      <Col span={8}>Tanggal Invoice</Col>
                      <Col span={16}>:&nbsp;{dataOrder.daya_invoice_date && dataOrder.daya_invoice_date !== "NONE" ? dayjs(dataOrder.daya_invoice_date).format("YYYY-MM-DD HH:mm") : "-"}</Col>
                    </Row>
                  </Col>
                </Row>
              </Tabs.TabPane>

              <Tabs.TabPane tab="Data Dokumen" key="4">
                <Row>
                  <Col xl={{ span: 8 }} lg={{ span: 8 }} md={{ span: 8 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Row>
                      <Col span={8}>No Notice</Col>
                      <Col span={16}>:&nbsp;{dataOrder.vehicle_notice_number}</Col>
                    </Row>
                    <Row>
                      <Col span={8}>Tgl Masuk</Col>
                      <Col span={16}>:&nbsp;{dataOrder.vehicle_notice_entry_date}</Col>
                    </Row>
                    <Row>
                      <Col span={8}>Tgl Keluar</Col>
                      <Col span={16}>:&nbsp;{dataOrder.vehicle_notice_submission_date}</Col>
                    </Row>
                  </Col>
                  <Col xl={{ span: 8 }} lg={{ span: 8 }} md={{ span: 8 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Row>
                      <Col span={8}>No BPKB</Col>
                      <Col span={16}>:&nbsp;{dataOrder.vehicle_certificate_of_ownership_number}</Col>
                    </Row>
                    <Row>
                      <Col span={8}>Tgl Masuk</Col>
                      <Col span={16}>:&nbsp;{dataOrder.vehicle_certificate_of_ownership_entry_date}</Col>
                    </Row>
                    <Row>
                      <Col span={8}>Tgl Keluar</Col>
                      <Col span={16}>:&nbsp;{dataOrder.vehicle_certificate_of_ownership_submission_date}</Col>
                    </Row>
                  </Col>
                  <Col xl={{ span: 8 }} lg={{ span: 8 }} md={{ span: 8 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Row>
                      <Col span={8}>No STNK</Col>
                      <Col span={16}>:&nbsp;{dataOrder.vehicle_registration_certificate_number}</Col>
                    </Row>
                    <Row>
                      <Col span={8}>Tgl Masuk</Col>
                      <Col span={16}>:&nbsp;{dataOrder.vehicle_registration_certificate_entry_date}</Col>
                    </Row>
                    <Row>
                      <Col span={8}>Tgl Keluar</Col>
                      <Col span={16}>:&nbsp;{dataOrder.vehicle_registration_certificate_submission_date}</Col>
                    </Row>
                  </Col>
                </Row>
                {dataOrder?.bpkb_scan_noted && (
                  <Row>
                    <Col xl={{ span: 16 }} lg={{ span: 16 }} md={{ span: 16 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ marginTop: 5 }}>
                      <strong>Catatan Upload BPKB : </strong><br />
                      {dataOrder.bpkb_scan_noted}
                    </Col>
                  </Row>
                )}
                {dataOrder?.bpkb_handover_image && dataOrder?.bpkb_handover_image?.includes("UPDATE VERSI GM PIC") && (
                  <Row>
                    <Col xl={{ span: 16 }} lg={{ span: 16 }} md={{ span: 16 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ color: "red" }}>
                      <Row>
                        <Col span={4}>Catatan</Col>
                        <Col span={20}>:&nbsp;{dataOrder.bpkb_handover_image}</Col>
                      </Row>
                    </Col>
                  </Row>
                )}
                {dataOrder?.vehicle_notice_image && dataOrder?.vehicle_notice_image !== "https://otodis-bucket.s3.ap-southeast-1.amazonaws.com/undefined" && (
                  <Row>
                    <Col style={{ padding: 10 }}>
                      <br />
                      <Image width={"inherit"} src={dataOrder?.vehicle_notice_image} style={{ alignContent: "center" }} />
                    </Col>
                  </Row>
                )}
                {/* {Array.isArray(dataOrder?.bpkb_entry_image) &&
                  dataOrder?.bpkb_entry_image?.map((item, index) => (
                    // <Row>
                    //   <Col key={index} style={{ padding: 10 }}>
                    //     <Image width={"inherit"} src={item.url} alt={`BPKB Image ${index + 1}`} style={{ alignContent: "center" }} />
                    //   </Col>
                    // </Row>
                  ))} */}
                {dataOrder?.bpkb_handover_image && !dataOrder.bpkb_handover_image.includes("UPDATE VERSI GM PIC") && (
                  <Row>
                    <Col style={{ padding: 10 }}>
                      <br />
                      <Image width={"inherit"} src={dataOrder?.bpkb_handover_image} style={{ alignContent: "center" }} />
                    </Col>
                  </Row>
                )}
                {dataOrder?.stnk_handover_image && dataOrder?.stnk_handover_image !== "https://otodis-bucket.s3.ap-southeast-1.amazonaws.com/undefined" && (
                  <Row>
                    <Col style={{ padding: 10 }}>
                      <br />
                      <Image width={"inherit"} src={dataOrder?.stnk_handover_image} style={{ alignContent: "center" }} />
                    </Col>
                  </Row>
                )}
              </Tabs.TabPane>
            </Tabs>
          </div>
        )}
      </Modal>
    );
  }
}

export default ModalDetailBBN;
